<template>
  <div>
    <h6> 
      {{before}}
      <span>{{number}}</span>
      <div class="portion-buttons">
        <button class="increase" @click="increase">+</button>
        <button class="decrease" @click="decrease">-</button>
      </div>
      {{after}}
    </h6>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        initial: 0,
        number: 0
      }
    },
    methods: {
      increase() {
        if(this.number < 10)
          this.number++,
          this.$parent.setPortion(this.number / this.initial)
      },
      decrease(){
        if(this.number > 1)
          this.number--,
          this.$parent.setPortion(this.number / this.initial)
      }
    },
    created() {
      let numberPosition;
      const numbers = /^\d+(\/\d+)*/
      const splitString = this.text.split(' ');
      this.number = splitString.find((word, index) => {
        if(word.match(numbers)){
          numberPosition = index
          return word
        }
      })
      this.initial = this.number
      this.before = splitString.slice(0,numberPosition).join(' ')
      this.after = splitString.slice(numberPosition + 1).join(' ')
    },
    props:['text']
  }
</script>

<style lang="scss" scoped>
  span{
    width: 35px;
    text-align: center;
    display: inline-block;
    background: var(--lgray);
  }
  .portion-buttons{
    display: inline-grid;
    vertical-align: middle;
    outline: none;
    margin-top: -1px;
    button{
      width: 15px;
      height: 15px;
      border: 1px solid rgba(0,0,0,0.1);
      background: var(--main);
      color: white;
      line-height: 0;
      padding: 0;
      cursor: pointer;
      &:focus{
        box-shadow: none;
        outline: none;
      }
      &:hover{
        background: var(--darker);
      }
      &:last-of-type{
        border-top: none;
        margin-top: -1px;
      }
    }
  }
</style>